import { WarehouseStepItem } from '@widgets/create-warehouse/step-list';
import { DefaultWarehouseStep, FixedWarehouseStep } from '../ts';

export const DEFAULT_WAREHOUSE_STEPS: WarehouseStepItem[] = [
  {
    key: DefaultWarehouseStep.Name,
    label: 'введите название склада',
  },
  {
    key: DefaultWarehouseStep.Perimeter,
    label: 'укажите периметр поля',
  },
  // {
  //   key: DefaultWarehouseStep.Angle,
  //   label: 'укажите уклон поля',
  // },
  {
    key: DefaultWarehouseStep.Entry,
    label: 'укажите въезд на поле',
  },
  {
    key: DefaultWarehouseStep.EntryOut,
    label: 'укажите выезд c поля',
  },
  {
    key: DefaultWarehouseStep.Type,
    label: 'выберите тип рукавов',
  },
];

export const FIXED_WAREHOUSE_STEP: WarehouseStepItem[] = [
  {
    key: FixedWarehouseStep.Name,
    label: 'введите название склада',
  },
  {
    key: FixedWarehouseStep.Coordinates,
    label: 'укажите координаты склада',
  },
];
